import { api } from '../index.js'

const pageSize = 20

export default {
  namespaced: true,

  state: {
    mailLogs: [],
    mailLogsPage: 0,
    mailLogsPageSize: pageSize,
    mailLogsTotalPages: 0,
    mailLogsSortBy: 'created_at',
    mailLogsSortDirection: 'desc'
  },

  mutations: {
    updateMailLogsPage(state, { attribute, value }) {
      state.mailLogsPage = value
    },

    updateMailLogs(state, { attribute, value }) {
      state.mailLogs = value
    },

    updateMailLogsTotalPages(state, { attribute, value }) {
      state.mailLogsTotalPages = value
    },

    updateMailLogsSortBy(state, { attribute, value }) {
      state.mailLogsSortBy = value
    },

    updateMailLogsSortDirection(state, { attribute, value }) {
      state.mailLogsSortDirection = value
    }
  },

  actions: {
    async fetchAll({ commit, state }, { id, page }) {
      page = parseInt(page, 10) || 1
      commit('updateMailLogsPage', { attribute: 'mailLogsPage', value: page })

      let [logs, res] = await api.mail_logs.all(id, page, state.mailLogsSortBy, state.mailLogsSortDirection)
      commit('updateMailLogs', { attribute: 'mailLogs', value: logs })

      if (res.headers.has('X-Pagination-Total-Pages')) {
        commit('updateMailLogsTotalPages', { attribute: 'mailLogsTotalPages', value: parseInt(res.headers.get('X-Pagination-Total-Pages'), 10) })
      }
    },

    updateMailLogsSort({ commit, state, dispatch }, { sortBy, sortDesc }) {
      let sortDirection = sortDesc ? 'desc' : 'asc'
      commit('updateMailLogsSortBy', { attribute: 'mailLogsSortBy', value: sortBy })
      commit('updateMailLogsSortDirection', { attribute: 'mailLogsSortDirection', value: sortDirection })
      return Promise.resolve({ sortBy, sortDirection })
    }
  }
}
